var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"px-10 pt-10 clearfix bg-gray-lightest h-full ccolumn-items w-full"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }